<section *ngIf="show" style="direction: ltr !important;">
    <!-- Side Navbar -->
    <!-- shrink -->
    <nav class="side-navbar printPl shrink" style="background-color: #808080;">
        <div class="side-navbar-wrapper printPl">
            <!-- Sidebar Header    -->
            <div class="sidenav-header d-flex align-items-center justify-content-center printPl" style="background-color:rgba(94, 93, 82, 1);position: sticky;top: 0 ; z-index: 1;">
                <!-- User Info-->
                <div class="sidenav-header-inner text-center">
                    <a routerLink='/dashboardHome'><img style="border-radius: 0 !important;width: 120px;height: 70px;" draggable="false" src="../../assets/video/logo.png" alt="person" class="img-fluid rounded-circle"></a>
                    <h2 style="cursor: default;" class="h5">{{name}}</h2><span style="cursor: default;color:white !important;">{{control}}</span>
                </div>
                <!-- Small Brand information, appears on minimized sidebar-->
                <div class="sidenav-header-logo printPl">
                    <a routerLink='/dashboardHome' class="brand-small text-center" style="color: white;"> <strong>N</strong></a>
                </div>
            </div>
            <!-- Sidebar Navigation Menus-->
            <div class="main-menu printPl">
                <h5 class="sidenav-heading" style="cursor: default;">Home</h5>
                <ul (click)='showI()' id="side-main-menu" class="side-menu list-unstyled">
                    <li *ngIf='Users' [class]="activeU">
                        <a routerLink="/users" style="font-weight: bold;"> <i class="icon-home"></i>Users</a>
                    </li>
                    <li *ngIf='Permession' [class]="activeCVEmPermession">
                        <a style="font-weight: bolder;" routerLink="/Permession"> <i class="fab fa-creative-commons-sa"></i>Permession</a>
                    </li>
                    <li *ngIf='Employees' [class]="activeCVEm">
                        <a style="font-weight: bolder;" routerLink="/Employees"> <i class="fas fa-users"></i>Employees</a>
                    </li>
                    <li *ngIf='Attendances' [class]="activeCVEmAttendances">
                        <a style="font-weight: bolder;" routerLink="/Attendances"> <i class="fas fa-battery-three-quarters"></i>Attendance</a>
                    </li>
                    <li *ngIf='Salary' [class]="activeCVEmAttendancesSalary">
                        <a style="font-weight: bolder;" routerLink="/Salary"> <i class="fas fa-money-check-alt"></i>Salary</a>
                    </li>
                    <!-- <li>
                      <a (click)='chic()' style="font-weight: bold;" href="#formsDropdown" aria-expanded="false" data-toggle="collapse"> <i class="fas fa-user-graduate"></i>الطلبة <i id="icol" class="fas fa-angle-left"></i><i id="icol0" class="fas fa-angle-down"></i></a>
                      <ul id="formsDropdown" class="collapse list-unstyled ">
                          <li><a routerLink='/admin/dashboardStudentRegister' style="font-weight: 400;">تسجيلات الطلبة</a></li>
                          <li><a routerLink='/admin/dashboardGroup' style="font-weight: 400;">المجاميع</a></li>
                          <li><a routerLink='/admin/allStudentGroup' style="font-weight: 400;">الطلاب</a></li>
                      </ul>
                  </li> -->
                    <!-- <li>
                      <a (click)='chic0()' style="font-weight: bold;" href="#formsDropdown1" aria-expanded="false" data-toggle="collapse"> <i class="fas fa-cog"></i>الأعدادات <i id="icol1" class="fas fa-angle-left"></i><i id="icol2" class="fas fa-angle-down"></i></a>
                      <ul id="formsDropdown1" class="collapse list-unstyled ">
                          <li><a routerLink='/admin/setting0' style="font-weight: 400;">تغيير كلمة السر</a></li>
                      </ul>
                  </li> -->
                    <li *ngIf='Branches' [class]="activeR">
                        <a style="font-weight: bolder;" routerLink="/root"> <i class="fas fa-map-marker-alt"></i>Branches</a>
                    </li>
                    <li *ngIf='Suppliers' [class]="activeS">
                        <a style="font-weight: bolder;" routerLink="/suppliers"> <i class="fas fa-diagnoses"></i>Supplier</a>
                    </li>
                    <li *ngIf='Category' [class]="activeC">
                        <a style="font-weight: bolder;" routerLink="/category"> <i class="fas fa-sitemap"></i>Category</a>
                    </li>
                    <!-- <li [class]="activeP">
                        <a style="font-weight: bolder;" routerLink="/payno"> <i class="fab fa-first-order"></i>الطلبيات
                        </a>
                    </li> -->
                    <li *ngIf='Items' [class]="activeI">
                        <a style="font-weight: bolder;" routerLink="/items"> <i class="fas fa-vote-yea"></i>Items</a>
                    </li>
                    <li *ngIf='Sellers' [class]="activeSE">
                        <a style="font-weight: bolder;" routerLink="/sellers"><i class="fas fa-diagnoses"></i> Sellers</a>
                    </li>
                    <li *ngIf='Brokers' [class]="activeSEB">
                        <a style="font-weight: bolder;" routerLink="/broker"><i class="fas fa-diagnoses"></i> Broker</a>
                    </li>
                    <li *ngIf='Customer' [class]="activeCV">
                        <a style="font-weight: bolder;" routerLink="/visit"> <i class="fas fa-users"></i>Customer</a>
                    </li>
                    <li *ngIf='Visit' [class]="activeCVV">
                        <a style="font-weight: bolder;" routerLink="/visitClient"> <i class="fas fa-users"></i>Visit</a>
                    </li>
                    <li *ngIf='Offer' [class]="activeCE">
                        <a style="font-weight: bolder;" routerLink="/sheet"> <i class="fas fa-cash-register"></i>Offer</a>
                    </li>
                    <li *ngIf='Quotations' [class]="activeCu">
                        <a style="font-weight: bolder;" routerLink="/quotations"> <i class="fas fa-shopping-cart"></i>Quotations</a>
                    </li>
                    <li *ngIf='Orders' [class]="activeCuO">
                        <a style="font-weight: bolder;" routerLink="/order"> <i class="fas fa-sort-amount-up"></i>Order</a>
                    </li>
                    <li *ngIf='Store' [class]="activeCuOStore">
                        <a style="font-weight: bolder;" routerLink="/store"> <i class="fas fa-store"></i>Store</a>
                    </li>
                    <li *ngIf='Request' [class]="activeCR">
                        <a style="font-weight: bolder;position: relative;" routerLink="/request"> <i class="fas fa-comments"></i>Request<span style='height: 20px;width: 20px;border-radius:50%;background-color:red;position:absolute;top:0;right: 0;color:white;font-size: 15px;line-height: 1.5;text-align: center;font-weight: bolder;'>{{allCaAnsRFNot.length + allCaAnsNot.length}}</span></a>
                    </li>
                    <!--
                    <li [class]="activeO">
                        <a style="font-weight: bolder;" routerLink="/operation"> <i class="fas fa-money-bill-alt"></i>Reports
                        </a>
                    </li> -->
                    <li *ngIf='Returns' [class]="activeHRE">
                        <a style="font-weight: bolder;" routerLink="/returns"> <i class="fas fa-undo"></i>Returns</a>
                    </li>
                    <li *ngIf='Reports' [class]="activeHReport">
                        <a style="font-weight: bolder;" routerLink="/report"> <i class="fas fa-print"></i>Reports</a>
                    </li>
                    <li *ngIf='ReportsPrivate' [class]="activeHReportPrivate">
                        <a style="font-weight: bolder;" routerLink="/PrivateReport"> <i class="fas fa-print"></i>Private Reports</a>
                    </li>
                    <li *ngIf='PaymentsReport' [class]="activeHReportPrivatePaymentsReport">
                        <a style="font-weight: bolder;" routerLink="/PaymentsReport"> <i class="fas fa-print"></i>Payments Reports</a>
                    </li>
                    <!-- <li *ngIf='AccountsGuide' [class]="activeHReportAccounts">
                        <a style="font-weight: bolder;" routerLink="/AccountsGuide"> <i class="fas fa-calculator"></i>Accounts Guide</a>
                    </li> -->
                    <!-- <li *ngIf='CashPayments' [class]="activeHReportCashPayments">
                        <a style="font-weight: bolder;" routerLink="/CashPayments"> <i class="fas fa-money-check-alt"></i>المدفوعات النقدية</a>
                    </li> -->
                    <!-- <li *ngIf='CashReceipts' [class]="activeCashReceipts">
                        <a style="font-weight: bolder;" routerLink="/CashReceipts"> <i class="fas fa-dollar-sign"></i>المتحصلات النقدية</a>
                    </li> -->
                    <!-- <li *ngIf='DailyRestrictions' [class]="activeDailyRestrictions">
                        <a style="font-weight: bolder;" routerLink="/DailyRestrictions"> <i class="fas fa-file-invoice-dollar"></i>Daily Restrictions</a>
                    </li> -->
                    <!-- <li *ngIf='GeneralReports' [class]="activeGeneralReports">
                        <a style="font-weight: bolder;" routerLink="/GeneralReports"> <i class="fas fa-print"></i>General Reports</a>
                    </li> -->
                    <li *ngIf='Histoty' [class]="activeH">
                        <a style="font-weight: bolder;" routerLink="/history"> <i class="fas fa-history"></i>History</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    <!-- active -->
    <div class="page active">
        <!-- navbar-->
        <header class="header pt-0 printPl" style="padding-bottom:0 !important">
            <nav class="navbar" style="background-color: #808080;">
                <div class="container-fluid">
                    <div class="navbar-holder d-flex align-items-center justify-content-between">
                        <div class="navbar-header" style="margin-left: 5px;"><a style="cursor: pointer;" (click)='togle()' id="toggle-btn" class="menu-btn shadow-lg"><i class="icon-bars"> </i></a>
                            <a routerLink='/admin/dashboardHome' class="navbar-brand">
                                <img style="border-radius: 0 !important;width: 120px;height: 70px;" draggable="false" src="../../assets/video/logo.png" alt="person" class="img-fluid rounded-circle">
                                <!-- <div class="brand-text d-none d-md-inline-block"><strong class="text-primary">N</strong> <strong class="text-primary">O</strong><strong class="text-primary">G</strong><strong class="text-primary">A</strong><strong class="text-primary">L</strong></div> -->
                            </a>
                        </div>
                        <h2 *ngIf='showI0' class="printAll printAll0" style="text-align: center;color:white !important;font-weight:bolder !important;">{{lenghtItem}} Items</h2>
                        <h2 *ngIf='showI1' class="printAll printAll0" style="text-align: center;color:white !important;font-weight:bolder !important;">Sales : {{sumSales}}</h2>
                        <ul class="nav-menu list-unstyled d-flex flex-md-row align-items-md-center">
                            <!-- Log out-->
                            <!-- <li class="nav-item dropdown">
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  اللغة
                                </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="#">Action</a>
                                        <a class="dropdown-item" href="#">Another action</a>
                                        <a class="dropdown-item" href="#">Something else here</a>
                                    </div>
                                </div>
                            </li> -->
                            <li class="nav-item">
                                <a (click)='goout()' style="cursor: pointer;" class="nav-link logout"> <span class="d-none d-sm-inline-block">Log Out</span><i class="fas fa-sign-out-alt"></i></a>
                            </li>
                            <li class="nav-item" *ngIf='Request'>
                                <a routerLink="/request" style="cursor: pointer;position:relative;" class="nav-link logout"> <span class="d-none d-sm-inline-block">Notifications</span><i class="fas fa-bell"></i><span style='height: 18px;width: 18px;border-radius:50%;background-color:red;position:absolute;top:0;right: 0;color:white;font-size: 13.2px;line-height: 1.5;text-align: center;font-weight: bolder;'>{{allCaAnsRFNot.length + allCaAnsNot.length}}</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
        <router-outlet></router-outlet>
        <footer class="main-footer printPl" style="background-color: #808080;">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        <p style="color: white;">جميع الحقوق محفوظة لشركة سفنكس للتكنولوجيا المتقدمة 01000122247</p>
                    </div>
                </div>
            </div>
        </footer>
    </div>

</section>
<app-login *ngIf="show2"></app-login>